import type { IValidatedResponse } from '../../../httpClient';
import { getRequest } from '../../../httpClient';
import type { IListSubscriptionsResponse } from '../listSubscriptions/list-subscriptions-response';
import { listSubscriptionsResponseSchema } from '../listSubscriptions/list-subscriptions-response';

export async function listUserSubscriptionsApi(
  userId: string,
): Promise<IValidatedResponse<IListSubscriptionsResponse>> {
  return getRequest<IListSubscriptionsResponse>({
    path: `/sys/billing/users/${userId}/subscriptions`,
    schema: listSubscriptionsResponseSchema,
  });
}
